import { FormGroup } from 'src/components/ui';

import { FormFieldProps } from '../FormComponentTypes';
import { LookupFieldObject } from './LookupFormField';
import OEFLookupConfigurationField from '../_formEditor/ObjectEditorField/LookupConfigurationField';
import { useMemo } from 'react';


export type LookupConfigurationField = FormFieldProps<LookupFieldObject, {
  type: "object",
  forCount?: boolean
}, {}>;

function LookupConfigurationField(props: LookupConfigurationField) {
  const {
    formData,
    disabled,
    readonly: propReadonly,
    schema: { title, forCount },
    fieldPathId: { $id },
    uiSchema: {
      'akc:requiredIfVisible': akcRequiredIfVisible,
      'ui:readonly': uiReadonly,
    },
    required: requiredProp,
    onChange: propOnChange,
  } = props;

  const readonly = propReadonly || uiReadonly;
  const required = requiredProp || akcRequiredIfVisible;
  const isDisabled = readonly || disabled;
  const fieldProps = useMemo(() => ({
    property: $id,
    forCount
  }), [$id, forCount]);

  return (
    <FormGroup disabled={isDisabled}>
      {title !== ' ' ? (
        <label className="control-label" htmlFor="root_preferredBranchId">
          {title}
          {required ? <span className="required">*</span> : null}
        </label>
      ) : null}
      <OEFLookupConfigurationField
        fieldProps={fieldProps}
        value={formData}
        readOnly={isDisabled}
        onChange={propOnChange}
      />
    </FormGroup>
  );
}


export default LookupConfigurationField;
